export enum SendTargetTypeEnum {
  LOCATION = "LOCATION",
  SUPPLY_CHAIN = "SUPPLY_CHAIN",
  DELIVERY = "DELIVERY",
  PROCESS = "PROCESS",
}
